import RightMenuBar from './RightMenuBar';

export default RightMenuBar;
